/* eslint-disable max-classes-per-file, class-methods-use-this */
import Bugsnag, { Client, Event } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { CONFIG } from '@/config';

interface ErrorNotifier {
  notify(error: Error, metaData?: Record<string, unknown>): void;
  isInitialized(): boolean;
}

class NoopErrorNotifier implements ErrorNotifier {
  notify(error: Error, metaData?: Record<string, unknown>): void {
    console.log(
      'NoopErrorNotifier: notify called. Error:',
      error,
      'Metadata:',
      metaData
    );
  }

  isInitialized(): boolean {
    console.log('NoopErrorNotifier: isInitialized called, returning false');
    return false;
  }
}

class BugsnagNotifier implements ErrorNotifier {
  private readonly bugsnagClient: Client;

  constructor() {
    this.bugsnagClient = Bugsnag.start({
      apiKey: CONFIG.bugsnagApiKey,
      plugins: [new BugsnagPluginReact()],
      appVersion: process.env.APP_VERSION,
      logger: null,
      onError(event) {
        const reportApp = event.app;
        const requestUrl = event.request.url;

        if (requestUrl?.match(/(?:.+\.)?boss\.az/g)) {
          reportApp.releaseStage = 'production';
          reportApp.notifyReleaseStages = 'production';
        } else {
          const releaseStage =
            process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF || 'staging';

          reportApp.releaseStage = releaseStage;
          reportApp.notifyReleaseStages = releaseStage;
        }
      }
    });
  }

  notify(error: Error, metaData?: Record<string, unknown>): void {
    this.bugsnagClient.notify(error, (event: Event) => {
      if (metaData) {
        event.addMetadata('custom', metaData);
      }
    });
  }

  isInitialized(): boolean {
    return !!this.bugsnagClient;
  }
}

export function createErrorNotifier(): ErrorNotifier {
  return CONFIG.bugsnagApiKey === 'DO_NOT_SEND'
    ? new NoopErrorNotifier()
    : new BugsnagNotifier();
}

export const errorNotifier = createErrorNotifier();
